import { render } from "./AboutOverview.vue?vue&type=template&id=069ee072"
import script from "./AboutOverview.vue?vue&type=script&lang=js"
export * from "./AboutOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__